import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import AnyErrorBoundary from '../../../components/global/AnyErrorBoundary';
import { selectModuleList } from '../model/selector';
import { getComponentList } from '../model/utils';
import * as allComps from '../../../components/index';
import ComponentsArrRenderer from '../../../components/core/ComponentsArrRenderer';

const CoreComponents = (props) => {
	const moduleList = useSelector(selectModuleList);
  const componentsToCore = useMemo(() => getComponentList(moduleList),  [moduleList]);

  return (
    <AnyErrorBoundary>
			<ComponentsArrRenderer {...props} allComps={allComps} components={componentsToCore} />
    </AnyErrorBoundary>
  );
};

export default CoreComponents;
